<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__info">
      <div class="info-text">
        Выберите процент гарантии для формирования договора
      </div>
    </div>

    <div class="form__item">
      <q-radio
        v-model="selectedWarranty"
        :val="warranty_contractor"
        :label="`Гарантия если закуп материала от подрядчика (${warranty_contractor}%)`"
        color="primary"
      />
    </div>

    <div class="form__item">
      <q-radio
        v-model="selectedWarranty"
        :val="warranty_team_project"
        :label="`Гарантия если закуп материала от команды проекта (${warranty_team_project}%)`"
        color="primary"
      />
    </div>

    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "SelectWarranty",
  components: { CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      selectedWarranty: null,
      warranty_contractor: this.data?.warranty_contractor ?? null,
      warranty_team_project: this.data?.warranty_team_project ?? null,
    };
  },
  methods: {
    async onSubmit() {
      if (this.selectedWarranty === null) {
        return;
      }
      this.loading = true;
      await this.data?.onSubmit(this.selectedWarranty);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 500px;
  gap: 15px;

  &__info {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;

    .info-text {
      color: #555;
      font-size: 14px;
      line-height: 1.5;
    }
  }

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 8px 0;
  }

  @media (max-width: 560px) {
    width: 100%;
  }
}
</style>
